import React from 'react';
import IGShareLinksSlideoutBannerNormalSrc from './IGShareLinksSlideoutBanner_normal.png';
import IGShareLinksSlideoutBannerWhiteSrc from './IGShareLinksSlideoutBanner_white.png';

export const IGShareLinksSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGShareLinksSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGShareLinksSlideoutBannerNormalSrc} />
  );
};
